// alert("script_connected");
$(document).on("click","#disabled_popup_button",function() {
  pincodeCheckText.style.display = 'block';
          setTimeout(() => {
            pincodeCheckText.style.display = 'none';
          }, 3000);
 });
const cod = 0;
var weight = document.getElementById("product-data").getAttribute("data-weight");
weight = weight/1000;
let apiurl = "https://ship.endurasupplements.com/api/pincode-checker";
const particularButton = document.getElementById("disabled_button");
particularButton.style.display = 'none';
// const disabled_popup_button = document.getElementById("disabled_popup_button");
const disabled_popup_button = document.getElementById("disabled_popup_button");
const pincodeCheckText = document.getElementById("pincode_check_msg");
 if (disabled_popup_button && pincodeCheckText) {
    // Initially hide the text
    pincodeCheckText.style.display = 'none';
  
  } else {
    console.error("Required elements not found in the DOM.");
  }
particularButton.classList.add('disabledButtonCart');
console.log("particularButton",particularButton)
const pinCodeFunction = async () => {
  const pinCode_button = document.getElementById("pinCode_button");
  pinCode_button.setAttribute("disabled", true)
  const pincodeCheckText = document.getElementById("pincode_check_msg")
  const disabled_button = document.getElementById('disabled_button')
  disabled_button.style.display = 'none';
  pincodeCheckText.style.display = 'none';
  
disabled_button.classList.add('disabledButtonCart');
console.log("disabled_button",disabled_button)
  // alert("")
   let e = document.getElementById("successMessage");
   e.innerHTML = "";
   let t = document.createElement("p"),
      n = document.createElement("p"),
      d = document.getElementById("errorMessage"),
      l = document.getElementById("pincode").value;
   d.innerHTML = "";
   let i = document.createElement("p");
   if (i.setAttribute("class", "errorMesclass"), isNaN(l)) i.innerHTML = "Kindly Enter Valid Pincode", d.appendChild(i), document.getElementById("disabled_button").disabled = !0;
   else if (/^\d{6}$/.test(l)) {
      let o = document.getElementById("pinCode_button");
      o.textContent = "EDIT";
      let r = {
         delivery_postcode: l,
         weight: weight,
         cod: 0
      };
      console.log(r), fetch(apiurl, {
         method: "POST",
         headers: {
            "Content-Type": "application/json"
         },
         body: JSON.stringify(r)
      }).then(e => e.json()).then(o => {
         console.log(o), "No Delivery Available" == o.message ? (document.getElementById("errorMessage").innerHTML = o.message, d.appendChild(i), document.getElementById("disabled_button").disabled = !0,disabled_popup_button.style.display = 'flex') : (t.innerHTML = o.title, n.innerHTML = o.message, t.style.color = "green", n.style.color = "black", e.appendChild(t), e.appendChild(n), document.getElementById("disabled_button").disabled = !1,disabled_button.style.display = 'flex',disabled_popup_button.style.display = 'none',particularButton.classList.remove('disabledButtonCart'), localStorage.setItem("PINCODE", l),pincodeCheckText.style.display = "none")
      }).catch(e => {
         console.error("Error:", e)
      })   .finally(() => {
    pinCode_button.removeAttribute("disabled");
               // console.log("Api call completed")
}),  finalDeliverydate(l)
   } else "" == l ? (i.innerHTML = "Empty not allowed", d.appendChild(i), document.getElementById("disabled_button").disabled = !0,disabled_popup_button.style.display = 'flex', pinCode_button.removeAttribute("disabled")) : (i.innerHTML = "Invalid Pincode", d.appendChild(i), document.getElementById("disabled_button").disabled = !0)
}, finalDeliverydate = e => {
   myFunction()
}, myFunction = () => {
   let e = document.getElementById("pincode").value;
   e > 0 ? console.log("button will be visible") : console.log("not visible")
}, inputField = document.querySelector(".userPincode"), storedPinCode = localStorage.getItem("PINCODE");
storedPinCode && (document.getElementById("pincode").value = storedPinCode, console.log("pincode their in local storage"), document.getElementById("errorMessage").innerHTML = "", pinCodeFunction());
var el = document.querySelector("#pincode");
el.onfocus = function () {
  setTimeout(() => {
    document.querySelector("#pinCode_button").innerHTML = "CHECK";
  }, 0);
};

el.onblur = function () {
  setTimeout(() => {
    document.querySelector("#pinCode_button").innerHTML = "EDIT";
  }, 0);
};
// el.addEventListener("focus", e => {
//    document.querySelector("#pinCode_button").innerHTML = "CHECK"
// }), el.addEventListener("focusout", e => {
//    document.querySelector("#pinCode_button").innerHTML = "EDIT"
// });





